import type { ArticleMeta } from '../types.ts';

import thumbSrc from './thumb.webp';

const year = new Date().getFullYear();

export const articleMeta = {
  slug: 'bli-kvitt-kredittkortgjeld',
  title: `Bli kvitt kredittkortgjeld i ${year}: 7 steg som faktisk fungerer`,
  description:
    'Nordmenn har i snitt 22 000 kr i kredittkortgjeld. Her er 7 konkrete steg for å bli kvitt kredittkortgjelden – uten å binde deg til boliglån.',
  tags: ['personlig-økonomi', 'gjeld', 'tips'],
  publishedAt: '2026-01-15',
  thumbSrc,
  thumbAlt: 'Et hvitt kredittkort delt i to, blå bakgrunn',
} satisfies ArticleMeta;
